import { render, staticRenderFns } from "./Parameter.vue?vue&type=template&id=7f98601b&scoped=true&"
import script from "./Parameter.vue?vue&type=script&lang=js&"
export * from "./Parameter.vue?vue&type=script&lang=js&"
import style0 from "./Parameter.vue?vue&type=style&index=0&id=7f98601b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f98601b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VChip,VIcon,VList,VListItem,VListItemContent,VMenu})
